// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"73dd79ab07a1f3b4","src_app_bulk-user-update_bulk-user-update_module_ts":"f93bbff5581c1cdb"}[chunkId] + ".js";
};